export interface PolicySearchConfigLike {
  method?: string;
}

/** The only two methods the CMS can actually search. Anything else means there is no source. */
const SEARCHABLE_METHODS = ['DB', 'API'];

/**
 * Whether the organization has a policy source worth rendering a search box for.
 *
 * Written as an allow-list rather than a `!== 'NONE'` deny-list because the config is absent, not
 * `NONE`, on every path that has not resolved one yet: `prepareOperationalDetails` returns `{}` for
 * a falsy payload, so a still-loading or replayed-empty organization context yields `undefined`.
 * A deny-list fails open there and renders a search box over nothing.
 */
export const hasPolicySource = (policySearchConfig?: PolicySearchConfigLike | null): boolean =>
  SEARCHABLE_METHODS.includes(policySearchConfig?.method ?? '');
